import styled from 'styled-components'

import { COLOR, NATIVE_BASE_COLORS, FONT_SIZE } from '../../../../themes'

export const StylesRepeatEnd = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  .title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .radio-layout {
    display: flex;
    flex-direction: 'row';
    align-items: center;
    min-width: 70px;
    margin-right: 42px;

    input[type='radio'] {
      width: 24px;
      height: 24px;
      accent-color: ${COLOR.BLACK_5};
      cursor: pointer;
      margin: 0;
    }
  }

  .radio-option {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    margin-left: 8px;
    cursor: pointer;
  }

  .ends-on-section {
    display: flex;
    margin-top: 16px;
  }

  .box-option {
    background-color: ${NATIVE_BASE_COLORS.TEXT[200]};
    border: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};
    padding: 0px 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .box-active-option {
    background-color: ${COLOR.BG_ACTIVE_DROPDOWN_REPEAT_BOOKING};
    border-radius: 4px;
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    padding: 0px 10px;
    cursor: pointer;
  }

  .padding-option {
    padding: 12px;
  }

  .box-option-text {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[600]};
    align-self: center;
    cursor: pointer;
  }

  .box-option-active-text {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    align-self: center;
    cursor: pointer;
  }

  .ends-after-section {
    display: flex;
    align-items: center;
    margin-top: 18px;
  }

  .occurrence-input {
    width: 20px;
    height: 42px;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[600]};
    text-align: center;
    outline: none;
    border-color: transparent;
    background-color: transparent;
    cursor: pointer;
  }

  .occurrence-arrow {
    display: flex;
    flex-direction: column;
    margin-left: 11px;
  }
`
